"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TOASTS_LIMIT: function() {
        return TOASTS_LIMIT;
    },
    TOAST_ANIMATION_DURATION_MS: function() {
        return TOAST_ANIMATION_DURATION_MS;
    },
    TOAST_TIMEOUT: function() {
        return TOAST_TIMEOUT;
    }
});
const TOASTS_LIMIT = 5;
const TOAST_TIMEOUT = 10000;
const TOAST_ANIMATION_DURATION_MS = 500;

//# sourceMappingURL=Toast.constants.js.map